import { render } from "./form-part-b-controlled-money.html?vue&type=template&id=c00e8fe0&scoped=true&ts=true&external"
import script from "./form-part-b-controlled-money.ts?vue&type=script&lang=ts&external"
export * from "./form-part-b-controlled-money.ts?vue&type=script&lang=ts&external"

import "./form-part-b-controlled-money.scss?vue&type=style&index=0&id=c00e8fe0&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c00e8fe0"]])

export default __exports__